import { useState } from "react";
import { ConvertTH, ConvertMonthTHFull } from "../../widgets/form/ConvertTime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/pro-solid-svg-icons";
import { faSpinner } from "@fortawesome/pro-solid-svg-icons";
import {
  fetchProtectedFile,
  handoffDownloadToExternalBrowser,
  openBlobFile,
  shouldUseLineExternalBrowserHandoff,
} from "../../utils/documentDownload";

// Download functions
const handleDownloadReceipt = async (data: any) => {
  if (!data?.receiptStreamUrl) return;

  const accessToken = localStorage.getItem('token');
  if (!accessToken) return;

  if (shouldUseLineExternalBrowserHandoff()) {
    handoffDownloadToExternalBrowser({
      accessToken,
      downloadType: 'receipt',
      fileName: data?.receiptFileName || 'receipt.pdf',
      streamUrl: data.receiptStreamUrl,
    });
    return;
  }

  try {
    const blob = await fetchProtectedFile({
      accessToken,
      streamUrl: data.receiptStreamUrl,
    });

    openBlobFile(blob, `${data?.receiptFileName}`);
  } catch (error) {
    console.error('Error downloading receipt:', error);
  }
};

const handleDownloadInvoice = async (data: any) => {
  if (!data?.invoiceStreamUrl) return;

  const accessToken = localStorage.getItem('token');
  if (!accessToken) return;

  if (shouldUseLineExternalBrowserHandoff()) {
    handoffDownloadToExternalBrowser({
      accessToken,
      downloadType: 'invoice',
      fileName: data?.invoiceFileName || 'invoice.pdf',
      streamUrl: data.invoiceStreamUrl,
    });
    return;
  }

  try {
    const blob = await fetchProtectedFile({
      accessToken,
      streamUrl: data.invoiceStreamUrl,
    });

    openBlobFile(blob, `${data?.invoiceFileName}`);
  } catch (error) {
    console.error('Error downloading invoice:', error);
  }
};

const DetailModal = ({ data, registration, historyData }: any) => {
  // Find current index in history array
  const currentIndex = historyData?.findIndex((item: any) => item.month === data?.month) ?? -1;
  const previousHistoryItem = currentIndex >= 0 && currentIndex < historyData.length - 1
    ? historyData[currentIndex + 1]
    : null;

  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <div style={{ fontFamily: 'Google Sans, sans-serif' }}>
        {/* Name and Address
        <div className="row mb-3">
          <div className="col-12 col-md-6 mb-2 mb-md-0">
            <div className="mb-1" style={{ fontSize: '14px', opacity: '0.5' }}>ชื่อผู้ใช้น้ำ</div>
            <div style={{ fontSize: '16px', color: '#2C2C2C', fontWeight: '500' }}>
              {registration?.name || "-"}
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="mb-1" style={{ fontSize: '14px', opacity: '0.5' }}>ที่อยู่</div>
            <div style={{ fontSize: '16px', color: '#2C2C2C' }}>
              {registration?.address || "-"}
            </div>
          </div>
        </div>


        <div className="row mb-3">
          <div className="col-12 col-md-6 mb-2 mb-md-0">
            <div className="mb-1" style={{ fontSize: '14px', opacity: '0.5' }}>ทะเบียนผู้ใช้น้ำ</div>
            <div style={{ fontSize: '16px', color: '#2C2C2C' }}>
              {registration?.registrationNumber || "-"}
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="mb-1" style={{ fontSize: '14px', opacity: '0.5' }}>หมายเลขมาตร</div>
            <div style={{ fontSize: '16px', color: '#4263B5', fontWeight: '500' }}>
              {registration?.meterNumber || "-"}
            </div>
          </div>
        </div> */}


        {/* <hr className="my-3" /> */}

        {/* Additional Details */}
        <div className="row mb-3">
          <div className="col-12 col-md-6 mb-3 mb-md-0">
            <div className="" style={{ fontSize: '14px', opacity: '0.5' }}>รอบบิล</div>
            <div style={{ fontSize: '16px', color: '#2C2C2C' }}>
              {data?.month ? ConvertMonthTHFull(data.month) : "-"}
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="" style={{ fontSize: '14px', opacity: '0.5' }}>วันที่ชำระ</div>
            <div style={{ fontSize: '16px', color: '#2C2C2C' }}>
              {data?.paymentDate && data.paymentDate !== "-" ? data.paymentDate : <span className="text-danger bg-danger-subtle p-1 px-2 rounded-2">ยังไม่ได้ชำระ</span>}
            </div>
          </div>
        </div>
        <div className="row ">
          <div className="col-12 col-md-6 mb-3 mb-md-0">
            <div className="" style={{ fontSize: '14px', opacity: '0.5' }}>หน่วยที่ใช้</div>
            <div style={{ fontSize: '16px', color: '#2C2C2C' }}>
              {data?.units || 0} หน่วย
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="" style={{ fontSize: '14px', opacity: '0.5' }}>ยอดชำระ</div>
            <div style={{ fontSize: '16px', color: '#2C2C2C' }}>
              {data?.amount || 0} บาท
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Export footer component separately
export const DetailModalFooter = ({ data, isMobile }: any) => {
  const [isDownloadingReceipt, setIsDownloadingReceipt] = useState(false);
  const [isDownloadingInvoice, setIsDownloadingInvoice] = useState(false);

  const handleDownloadReceiptWithLoading = async (data: any) => {
    if (isDownloadingReceipt || !data?.receiptStreamUrl) return;

    setIsDownloadingReceipt(true);
    try {
      await handleDownloadReceipt(data);
    } catch (error) {
      console.error('Error downloading receipt:', error);
    } finally {
      setIsDownloadingReceipt(false);
    }
  };

  const handleDownloadInvoiceWithLoading = async (data: any) => {
    if (isDownloadingInvoice || !data?.invoiceStreamUrl) return;

    setIsDownloadingInvoice(true);
    try {
      await handleDownloadInvoice(data);
    } catch (error) {
      console.error('Error downloading invoice:', error);
    } finally {
      setIsDownloadingInvoice(false);
    }
  };

  if (!data?.receiptStreamUrl && !data?.invoiceStreamUrl) {
    return null;
  }

  return (
    <div style={{
      padding: '16px 0px 0px 0px',
      borderTop: '1px solid #E0E0E0',
      backgroundColor: '#FFFFFF',
      position: 'sticky',
      bottom: 0,
      zIndex: 10
    }}>
      <div className="d-flex gap-2 w-fit justify-content-center">
        {data?.receiptStreamUrl && (
          <button
            onClick={() => handleDownloadReceiptWithLoading(data)}
            disabled={isDownloadingReceipt}
            style={{
              backgroundColor: '#4263B5',
              color: '#FFFFFF',
              border: 'none',
              borderRadius: '8px',
              padding: '8px 16px',
              fontSize: '14px',
              cursor: isDownloadingReceipt ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              fontFamily: 'Google Sans, sans-serif',
              fontWeight: '500',
              width: '100%',
              margin: '0 auto',
              opacity: isDownloadingReceipt ? 0.7 : 1
            }}
            title="ดาวน์โหลดใบเสร็จ"
          >
            {isDownloadingReceipt ? (
              <FontAwesomeIcon icon={faSpinner} spin style={{ fontSize: '14px' }} />
            ) : (
              <FontAwesomeIcon icon={faDownload} style={{ fontSize: '14px' }} />
            )}
            <span style={{ fontSize: isMobile ? '10px' : '14px' }}>
              {isDownloadingReceipt ? 'กำลังดาวน์โหลด...' : 'ดาวน์โหลดใบเสร็จ'}
            </span>
          </button>
        )}
        {data?.invoiceStreamUrl && (
          <button
            onClick={() => handleDownloadInvoiceWithLoading(data)}
            disabled={isDownloadingInvoice}
            style={{
              backgroundColor: '#f8f9ff',
              color: '#4263B5',
              border: '1px solid #4263B5',
              borderRadius: '8px',
              padding: '8px 16px',
              fontSize: '14px',
              cursor: isDownloadingInvoice ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              fontFamily: 'Google Sans, sans-serif',
              fontWeight: '500',
              width: '100%',
              margin: '0 auto',
              opacity: isDownloadingInvoice ? 0.7 : 1
            }}
            title="ดาวน์โหลดใบแจ้งหนี้"
          >
            {isDownloadingInvoice ? (
              <FontAwesomeIcon icon={faSpinner} spin style={{ fontSize: '14px' }} />
            ) : (
              <FontAwesomeIcon icon={faDownload} style={{ fontSize: '14px' }} />
            )}
            <span style={{ fontSize: isMobile ? '10px' : '14px' }}>
              {isDownloadingInvoice ? 'กำลังดาวน์โหลด...' : 'ดาวน์โหลดใบแจ้งหนี้'}
            </span>
          </button>
        )}
      </div>
    </div>
  );
};

export { DetailModal };
